var _circle, _path, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleSolidWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 121,
    viewBox: "0 0 122 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61.0007,
    cy: 60.1433,
    r: 60.1433,
    fill: "#FFAD0D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 62.9167V48.3333M34.75 60C34.75 45.5025 46.5025 33.75 61 33.75C75.4975 33.75 87.25 45.5025 87.25 60C87.25 74.4975 75.4975 86.25 61 86.25C46.5025 86.25 34.75 74.4975 34.75 60Z",
    stroke: "#F9FAFC",
    strokeWidth: 5.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.9993,
    cy: 73.1248,
    r: 2.91667,
    transform: "rotate(180 60.9993 73.1248)",
    fill: "#F9FAFC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleSolidWarning);
export default __webpack_public_path__ + "static/media/circle-solid-warning.767c64f877fe333a209b59f9c3ebe927.svg";
export { ForwardRef as ReactComponent };